import type { MctProvider } from ".";

export function isMctProvider(value: unknown): value is MctProvider {
  const obj = value as Record<string, unknown>;
  return (
    typeof obj.npi === "string" &&
    typeof obj.firstName === "string" &&
    typeof obj.lastName === "string" &&
    typeof obj.credentials === "string" &&
    typeof obj.specialties === "string" &&
    Array.isArray(obj.locations)
  );
}
